import React, { CSSProperties, useState, useEffect } from "react";
import Layout from "../../Layout";
import CatalogsLayout from "Components/CatalogsLayout";
import Grid, { TextFilter, SelectColumnFilter } from "Components/Grid";
import CatalogsModal from "Components/CatalogsModal";
import Buttons from "../../Components/Buttons";
import { useSelector, useDispatch } from "react-redux";
import { Dispatch } from "redux";
import {
  addOperationType,
  getOperationTypes,
  updateOperationType,
} from "actions/tipoOperacion";
import FormTipoOperacion from "Forms/TipoOperacion";
import { IOperationType } from "Interfaces/IOperationType";
import ConfirmationModal from "Components/ConfirmationModal";
import { validateForm } from "../../utils";

import { getBrands } from "actions/marca";
import { getOperationTypesSCById } from "actions/sc";

const TipoOperacion = () => {
  const defaultItem = {
    idTipoOperacion: 0,
    idMarca: 0,
    idMarcaSc: 0,
    marca: "",
    codigoTipoOperacion: "",
    tipoOperacion: "",
    logo: "",
    idEstatus: 1,
  };

  const [title] = useState("Tipos de Operación");
  const [open, setOpen] = useState<boolean>(false);
  const [openConfirm, setOpenConfirm] = useState<boolean>(false);
  const [action, setAction] = useState<string>("");
  const [operationTypes, setOperationTypes] = useState<any>();
  const [errors, setErrors] = useState<IOperationType>({});
  const [formValues, setFormValues] = useState<any>({});
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isLoadingGrid, setIsLoadingGrid] = useState<boolean>(true);
  const [brands, setBrands] = React.useState<Array<any>>([]);
  const [brandsSc, setBrandsSc] = React.useState<Array<any>>([]);

  const dispatch: Dispatch = useDispatch();

  const { catalogs } = useSelector((state: any) => state.theme);
  const { btnSimple } = useSelector((state: any) => state.theme);

  const styles: CSSProperties = {
    fontSize: `clamp(1.6rem, 2.5vw, 2rem)`,
    backgroundColor: catalogs.background,
  };

  const loadOperationTypes = () => {
    getOperationTypes(0).then((res) => {
      if (res) setOperationTypes(res);
      setIsLoadingGrid(false);
    });
  };

  useEffect(() => {
    loadOperationTypes();
    handleBrands();
  }, []);

  const handleBrands = () => {
    getBrands(0).then((res) => {
      if (res) {
        res.unshift({
          idMarca: 0,
          marca: "Seleccionar",
          idMarcaSc: 0,
        });

        setBrands(
          res.map((e: any) => {
            return {
              value: e.idMarca,
              text: e.marca,
              idMarcaSc: e.idMarcaSc,
            };
          })
        );
      }
    });
  };

  const handleBrandsSc = (idBrand: number) => {
    getOperationTypesSCById(idBrand).then((res) => {
      if (res) {
        let options: Array<any> = res.map((e: any) => {
          return {
            value: e.idTipoOperacion,
            text: e.tipoOperacion,
          };
        });
        setBrandsSc([
          {
            value: 0,
            idMarcaSc: 0,
            text: "Seleccionar",
          },
          ...options,
        ]);
      }
    });
  };

  const handleAddClick = () => {
    setAction("add");
    setErrors({});
    setFormValues(defaultItem);
    setOpen(true);
  };

  const handleView = (item: any) => {
    setAction("view");
    setFormValues(item);
    setOpen(true);
  };

  const handleEdit = (item: any) => {
    setAction("edit");
    setErrors({});
    setFormValues(item);
    handleBrandsSc(item.idMarcaSc);
    setOpen(true);
  };

  const handleStatus = (item: any) => {
    const { idTipoOperacion, idEstatus, idMarca, tipoOperacion } = item;
    setFormValues({
      idTipoOperacion,
      idEstatus: idEstatus === 1 ? 0 : 1,
      idMarca,
      tipoOperacion,
    });
    setOpenConfirm(true);
  };

  const handleConfirm = () => {
    setIsLoading(true);
    let form = new FormData();
    for (let key in formValues) {
      form.append(key, formValues[key]);
    }
    updateOperationType(formValues.idTipoOperacion, form, true).then((res) => {
      if (res) {
        loadOperationTypes();
        setOpenConfirm(false);
        dispatch({
          type: "REMOVE_OPERATION_TYPE_LIST",
        });
      }
      setIsLoading(false);
    });
  };

  const handleCancelConfirm = () => {
    setOpenConfirm(false);
    loadOperationTypes();
  };

  const handleOnChange = (e: any) => {
    let value = e.target.value;
    let id = e.target.id;

    let itemError: any = errors;
    delete itemError[id];
    setErrors(itemError);

    if (value && id === "idMarca") {
      let marcaSC = brands.find((item: any) => item.value === +value);
      setFormValues({
        ...formValues,
        idMarca: value,
        idMarcaSc: marcaSC.idMarcaSc,
      });
      handleBrandsSc(marcaSC.idMarcaSc);
      return;
    }

    if (value && id === "idTipoOperSc") {
      let index = e.nativeEvent.target.selectedIndex;
      setFormValues({
        ...formValues,
        idTipoOperSc: value,
        tipoOperacion: index !== 0 ? e.nativeEvent.target[index].text : "",
      });
      return;
    }

    setFormValues({
      ...formValues,
      [id === "_inputFile" ? "imagen" : id]:
        id === "_inputFile" ? e.target.files[0] : value,
      [id === "_inputFile" ? "logo" : id]:
        id === "_inputFile" ? e.target.files[0].name : value,
    });
  };

  const handleAccept = () => {
    if (!handleValidation()) {
      return false;
    }
    setIsLoading(true);
    if (action === "add") {
      let form = new FormData();
      for (let key in formValues) {
        form.append(key, formValues[key]);
      }
      addOperationType(form).then((res) => {
        if (res) {
          loadOperationTypes();
          setOpen(false);
          setFormValues({});
          dispatch({
            type: "REMOVE_OPERATION_TYPE_LIST",
          });
        }
        setIsLoading(false);
      });
    }
    if (action === "edit") {
      let form = new FormData();
      for (let key in formValues) {
        if (formValues[key]) {
          form.append(key, formValues[key]);
        }
      }
      updateOperationType(formValues.idTipoOperacion, form).then((res) => {
        if (res) {
          loadOperationTypes();
          setOpen(false);
          setFormValues({});
          dispatch({
            type: "REMOVE_OPERATION_TYPE_LIST",
          });
        }
        setIsLoading(false);
      });
    }
  };

  const handleValidation = () => {
    let isValid = validateForm({
      schema: {
        idMarca: {
          message: "Selecciona la marca",
          validate: (value: any) => {
            if (value === "0") {
              return {
                valid: false,
                message: "Selecciona la marca",
              };
            }
            return {
              valid: true,
              message: "",
            };
          },
        },
        idMarcaSc: {
          message: "Selecciona el tipo marca SC",
          optional: (formValues?.idTipoOperacion || 0) > 0 ? false : true,
        },
        tipoOperacion: { message: "Ingrese el alias" },
        codigoTipoOperacion: { message: "Ingrese el código" },
        idTipoOperSc: {
          message: "Selecciona el tipo de operación SC",         
        },
        imagen: {
          message: "Selecciona una imagen",
          optional: true,
          validate: (value: any) => {
            let rgx = /\.(gif|jpe?g|png)$/i;
            let match = value.name.match(rgx);

            if (match === null) {
              return {
                valid: false,
                message: "Formato de imagen no válido (.png .jpg)",
              };
            }

            if (parseFloat((value.size / (1024 * 1024)).toFixed(2)) > 5) {
              return {
                valid: false,
                message: "El peso de la imagen rebasa los 5MB soportados",
              };
            }

            return {
              valid: true,
              message: "",
            };
          },
        },
      },
      values: formValues,
    });

    console.log(isValid,formValues.idMarcaSc);

    if (Object.keys(isValid).length) {
      setErrors({ ...isValid });
      return false;
    }
    return true;
  };

  const handleCancel = () => {
    setOpen(false);
    loadOperationTypes();
  };

  const columns = [
    {
      accessor: "idMarca",
      Header: "ID Marca",
      Filter: TextFilter,
      filter: "text",
    },
    {
      accessor: "marca",
      Header: "Marca",
      Filter: TextFilter,
      filter: "text",
    },
    {
      accessor: "idMarcaSc",
      Header: "IDMarcaSC",
      Filter: TextFilter,
      filter: "text",
    },
    {
      accessor: "idTipoOperacion",
      Header: "ID Tipos de Operación",
      Filter: TextFilter,
      filter: "text",
    },
    {
      accessor: "tipoOperacion",
      Header: "Tipos de Operación",
      Filter: TextFilter,
      filter: "text",
    },
    {
      accessor: "idTipoOperSc",
      Header: "ID TO SC",
      Filter: TextFilter,
      filter: "text",
    },
    {
      accessor: "codigoTipoOperacion",
      Header: "Código",
      Filter: TextFilter,
      filter: "text",
    },
    {
      accessor: "estatus",
      Header: "Estatus",
      Filter: SelectColumnFilter,
      filter: "includes",
    },
  ];

  const config: any = {
    actions: [
      {
        action: "view",
        tooltip: "Detalles",
        visible: true,
        handle: handleView,
        color: "#0079ab",
        icon: "search",
      },
      {
        action: "edit",
        tooltip: "Editar",
        visible: true,
        handle: handleEdit,
        color: "#ffb300",
        icon: "edit",
      },
      {
        action: "status",
        tooltip: "Estatus",
        visible: true,
        handle: handleStatus,
        color: "#00a176",
        icon: "check",
        isStatus: "idEstatus",
        colorNegative: "#f15642",
        iconNegative: "clear",
      },
    ],
  };

  return (
    <Layout theme={styles}>
      <>
        <CatalogsLayout bannerTitle={title}>
          <>
            <Grid
              columns={columns}
              data={operationTypes || []}
              config={config}
              isLoading={isLoadingGrid}
            >
              <Buttons
                title={"Nuevo Tipo Operación"}
                type={"add-catalog"}
                config={btnSimple}
                handleClick={handleAddClick}
              />
            </Grid>
            {open && (
              <CatalogsModal
                open={open}
                action={action}
                title={title}
                modalSize={action === "view" ? "md" : "lg"}
                isLoading={isLoading}
                handleAcceptClick={handleAccept}
                handleCancelClick={handleCancel}
              >
                <FormTipoOperacion
                  item={formValues}
                  action={action}
                  errors={errors}
                  handleOnChange={handleOnChange}
                  options={{
                    brands: brands,
                    operaciones: brandsSc,
                  }}
                />
              </CatalogsModal>
            )}
            {openConfirm && (
              <ConfirmationModal
                open={openConfirm}
                description={`¿Está seguro de ${
                  formValues.idEstatus === 1 ? "activar" : "desactivar"
                } el tipo de operación ${formValues?.tipoOperacion}?`}
                modalSize={"sm"}
                isLoading={isLoading}
                handleConfirmClick={handleConfirm}
                handleCancelClick={handleCancelConfirm}
              ></ConfirmationModal>
            )}
          </>
        </CatalogsLayout>
      </>
    </Layout>
  );
};

export default TipoOperacion;
